import { type PropsWithChildren, type ReactNode } from 'react';

import { getHeaders } from '@/lib/api/authMiddleware';

import { type Props as ButtonProps } from '../shadcn/button';

import GenerateLinkButton from './GenerateLinkButton';

type Props = PropsWithChildren<
  {
    link: string;
    generateLabel: string | ReactNode;
    onGenerate?: VoidFunction;
  } & Omit<ButtonProps, 'onSubmit'>
>;

export default function GenerateDocumentButton({
  generateLabel,
  children,
  link,
  onGenerate,
  ...props
}: Props) {
  const generate = async () => {
    const url = new URL(link);

    // Fuck this shit
    if (import.meta.env.DEV) url.host = 'localhost:3000';

    await fetch(url.toString(), {
      headers: {
        ...getHeaders(),
        'content-type': 'application/json',
      },
    });

    onGenerate?.();
  };

  const documentLink = link.includes('/v1/api/documents') ? link : undefined;

  return (
    <GenerateLinkButton
      generate={generate}
      generateLabel={generateLabel}
      link={documentLink}
      {...props}
    >
      {children}
    </GenerateLinkButton>
  );
}
